import { CupBookingContextValue } from "./CupBookingContext";

export enum CupBookingActionsKeys {
    SET_PRESTAZIONE = 'SET_PRESTAZIONE',
}

export type CupBookingActions = {
    type: CupBookingActionsKeys.SET_PRESTAZIONE,
    payload: CupBookingContextValue['prestazione']
}

export const contextReducer = (
    state: CupBookingContextValue,
    action: CupBookingActions
) => {
    switch (action.type) {
        case 'SET_PRESTAZIONE':
            return {
                ...state,
                prestazione: action.payload
            }
    
        default:
            return state;
    }
}